import React from "react"
import { batch } from "@preact/signals-react"

import { AppAntSwitch } from "@components"
import { mainSiteProvider, mainProvider, mainSite } from "@signals"


export default function AppCommonFiltersMainSiteProviderToggleButton({ ...props }) {
	return <AppAntSwitch
		falseText="Main Site"
		trueText="Main Provider"
		checked={mainSiteProvider.value}
		onChange={newValue => batch(() => {
			mainSiteProvider.value = newValue.target.checked
			mainSite.value = ''
			mainProvider.value = ''
		})}
		{...props}
	/>
}
